import React from 'react';

export const CreatePostUserInfo: React.FC = () => {
  return (
    <div className="w-full h-10 px-4 flex items-center gap-3">
      <div className="size-10 relative">
        <img
          className="size-10 rounded-full"
          src="/avatars/avatar.svg"
          alt="User avatar"
        />
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-[#1E3A3A] text-base font-medium font-sora leading-tight">
          Chihiro
        </div>
      </div>
    </div>
  );
}; 